import LateralIconsConfiguration from './layout/lateral/LateralIconsConfiguration.vue'

export default [
  {
    path: '/iconos',
    name: 'iconos',
    component: LateralIconsConfiguration
  }
]
